import { render, staticRenderFns } from "./organMgr.vue?vue&type=template&id=3dfc5802&scoped=true"
import script from "./organMgr.vue?vue&type=script&lang=js"
export * from "./organMgr.vue?vue&type=script&lang=js"
import style0 from "./organMgr.vue?vue&type=style&index=0&id=3dfc5802&prod&lang=less&scoped=true"
import style1 from "./organMgr.vue?vue&type=style&index=1&id=3dfc5802&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfc5802",
  null
  
)

export default component.exports